import { Icon, IconName, Tooltip } from '@aloft/toolkit-sui';

type SourceIconSlotProps = {
  show: boolean;
  icon: IconName;
  tooltipLabel: string;
};

export const SourceIconSlot = ({ show, icon, tooltipLabel }: SourceIconSlotProps) =>
  show ? (
    <Tooltip label={tooltipLabel}>
      <Icon icon={icon} />
    </Tooltip>
  ) : (
    <div style={{ width: '16px', height: '16px' }} aria-hidden />
  );
